"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _lodash = require("lodash");
var _ui = require("@unite-us/ui");
var _AllOrOne = _interopRequireDefault(require("../../AllOrOne"));
var _EmailAddress = _interopRequireDefault(require("../EmailAddress"));
var _Location = _interopRequireDefault(require("../../locations/Location"));
var _PhoneNumbers = _interopRequireDefault(require("../PhoneNumbers"));
var _arrays = _interopRequireDefault(require("../../utils/arrays"));
var _urls = _interopRequireDefault(require("../../utils/urls"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var ContactInformation = function ContactInformation(_ref) {
  var addressCount = _ref.addressCount,
    addresses = _ref.addresses,
    className = _ref.className,
    email_addresses = _ref.email_addresses,
    headerText = _ref.headerText,
    hideLabels = _ref.hideLabels,
    isInNetworkGroup = _ref.isInNetworkGroup,
    openLink = _ref.openLink,
    originLatLng = _ref.originLatLng,
    phone_numbers = _ref.phone_numbers,
    primary_contact_name = _ref.primary_contact_name,
    showContactInfoHeader = _ref.showContactInfoHeader,
    showLocationHours = _ref.showLocationHours,
    showMore = _ref.showMore,
    website_url = _ref.website_url,
    serve = _ref.serve;
  var primaryEmail = _arrays["default"].findPrimaryOrFirst(email_addresses);
  var emailAdresses = (0, _lodash.compact)([primaryEmail].concat(_toConsumableArray((0, _lodash.without)(email_addresses, primaryEmail))));
  var validExternalUrl = _urls["default"].addHttpIfNeeded(website_url);
  var showHeader = showContactInfoHeader && (!(0, _lodash.isEmpty)(email_addresses) || !(0, _lodash.isEmpty)(phone_numbers) || !(0, _lodash.isEmpty)(primary_contact_name) || !(0, _lodash.isEmpty)(website_url));
  var handleOpenLink = function handleOpenLink(e) {
    e.preventDefault();
    openLink(validExternalUrl);
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "ui-contact-information ".concat(className)
  }, showHeader && /*#__PURE__*/_react["default"].createElement("h4", {
    className: "ui-contact-information__header mb-half"
  }, headerText), primary_contact_name ? /*#__PURE__*/_react["default"].createElement("div", {
    className: "ui-contact-information__worker mb-half"
  }, /*#__PURE__*/_react["default"].createElement(_ui.Icon, {
    className: "ui-contact-information__icon mr-half",
    color: "".concat(isInNetworkGroup ? '#4571BA' : '#2C405A'),
    icon: "IconUserCircle"
  }), /*#__PURE__*/_react["default"].createElement("span", {
    className: "ui-contact-information__worker--name pl-quarter"
  }, primary_contact_name)) : null, /*#__PURE__*/_react["default"].createElement(_AllOrOne["default"], null, !serve && addresses && addresses.map(function (location) {
    return /*#__PURE__*/_react["default"].createElement(_Location["default"], {
      addressCount: addressCount,
      className: "ui-contact-information__location mb-quarter",
      hideLocationName: false,
      isInNetworkGroup: isInNetworkGroup,
      location: location,
      originLatLng: originLatLng,
      showHours: showLocationHours,
      showMore: showMore
    });
  })), /*#__PURE__*/_react["default"].createElement(_AllOrOne["default"], {
    showAll: showMore
  }, phone_numbers && /*#__PURE__*/_react["default"].createElement(_PhoneNumbers["default"], {
    hideLabels: hideLabels,
    isInNetworkGroup: isInNetworkGroup,
    phone_numbers: phone_numbers
  })), /*#__PURE__*/_react["default"].createElement(_AllOrOne["default"], {
    showAll: showMore
  }, !(0, _lodash.isEmpty)(email_addresses) && emailAdresses.map(function (email) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: "email-".concat(email !== null && email !== void 0 && email.email_address ? email.email_address : email),
      className: "ui-contact-information__email mb-half"
    }, /*#__PURE__*/_react["default"].createElement(_ui.Icon, {
      className: "ui-contact-information__icon--email mr-half",
      color: "".concat(isInNetworkGroup ? '#4571BA' : '#2C405A'),
      icon: "IconEnvelope"
    }), /*#__PURE__*/_react["default"].createElement(_EmailAddress["default"], {
      className: "ui-contact-information__icon-text pl-quarter",
      emailAddress: email
    }));
  })), website_url ? /*#__PURE__*/_react["default"].createElement("div", {
    className: "ui-contact-information__website mb-half"
  }, /*#__PURE__*/_react["default"].createElement(_ui.Icon, {
    className: "ui-contact-information__icon mr-half",
    color: "".concat(isInNetworkGroup ? '#4571BA' : '#2C405A'),
    icon: "IconGlobe"
  }), /*#__PURE__*/_react["default"].createElement("a", {
    id: "website-link",
    className: "ui-contact-information__icon-text--website pl-quarter",
    href: "#",
    onClick: handleOpenLink,
    title: 'Organization Website',
    target: "_blank",
    rel: "noreferrer noopener"
  }, validExternalUrl)) : null);
};
ContactInformation.propTypes = {
  addressCount: _propTypes["default"].string,
  addresses: _propTypes["default"].array,
  className: _propTypes["default"].string,
  email_addresses: _propTypes["default"].array,
  headerText: _propTypes["default"].node,
  hideLabels: _propTypes["default"].bool,
  isInNetworkGroup: _propTypes["default"].bool,
  openLink: _propTypes["default"].func,
  originLatLng: _propTypes["default"].array,
  phone_numbers: _propTypes["default"].array,
  primary_contact_name: _propTypes["default"].string,
  showContactInfoHeader: _propTypes["default"].bool,
  showLocationHours: _propTypes["default"].bool,
  showMore: _propTypes["default"].bool,
  website_url: _propTypes["default"].string,
  serve: _propTypes["default"].bool
};
ContactInformation.defaultProps = {
  addressCount: '',
  addresses: [],
  className: '',
  email_addresses: [],
  headerText: 'Contact Information',
  hideLabels: false,
  isInNetworkGroup: true,
  openLink: window.open,
  originLatLng: [],
  phone_numbers: [],
  primary_contact_name: '',
  showContactInfoHeader: true,
  showLocationHours: false,
  showMore: false,
  website_url: '',
  serve: false
};
var _default = exports["default"] = ContactInformation;